import Vue from "vue"
import Vuex from "vuex"
import home from "@/store/module/home"



Vue.use(Vuex)

export default new Vuex.Store({
	modules: { home }
})